
import moment from 'moment';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  Connection, PermissionCode, User,
} from '@/types';
import DatePicker from '@/components/DatePicker.vue';

moment.locale('it');

@Component({
  components: {
    DatePicker,
  },
})
export default class ConnectionRDESendDate extends Vue {
  @Prop(Object) readonly connection!: Connection;

  loading = false

  // Il valore utilizzato e gestito nel DatePicker
  // nel formato '2023-02-24'
  rdeSendingDate: string | null = null;

  created() {
    // console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console

    // Trasforma il Date in '2023-02-24T23:00:00.000Z' poi in '2023-02-24'
    this.rdeSendingDate = this.rdeSendingDateValue
      ? moment(this.rdeSendingDateValue).toISOString(true).substring(0, 10)
      : null;
  }

  // Il valore di tipo Date memorizzato nel DB
  get rdeSendingDateValue(): Date | null {
    return this.connection?.rdeSendingDate ?? null;
  }

  // Se il valore memorizzato nel DB cambia...
  @Watch('rdeSendingDateValue')
  onValue(val: Date | null) {
    // ... aggiorna il valore gestito dal DatePicker
    console.log(`${this.constructor.name}: onValue()`); // eslint-disable-line no-console

    // Trasforma il Date in '2023-02-24T23:00:00.000Z' poi in '2023-02-24'
    this.rdeSendingDate = val
      ? moment(val).toISOString(true).substring(0, 10)
      : null;
  }

  get rdeSendingDateString(): string | null {
    return this.rdeSendingDate
      && moment(this.rdeSendingDate).isValid()
      ? moment(this.rdeSendingDate).format('L')
      : null;
  }

  get user(): User { return this.$store.getters.currentUser; }
  get userPermissions(): PermissionCode[] { return this.$store.getters.currentUserPermissions; }
  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  get isDisabled() {
    return this.loading;
  }

  get isEditable() {
    if (!this.connection) return false;

    return this.connection
      && (this.connection.status === 'open' || this.connection.status === 'new')
      && this.hasPermission('rdeSendingDate.edit');
  }

  get columnClass(): string {
    // Se presente la data colora la colonna di verde
    return this.rdeSendingDate !== null ? 'green' : '';
  }

  async onSelect(newValue: Date | null) {
    console.log(`${this.constructor.name}: onSave() newValue =`, newValue); // eslint-disable-line no-console

    // Assegna il valore in modo che sia subito mostrato quello aggiornato
    // anche se effettivamente non è ancora stato salvato.
    // Trasforma il Date in '2023-02-24T23:00:00.000Z' poi in '2023-02-24'
    this.rdeSendingDate = newValue
      ? moment(newValue).toISOString(true).substring(0, 10)
      : null;

    // Prepara l'aggiornamento
    const update = {
      rdeSendingDate: newValue,
    } as { [key: string]: unknown };

    // Disabilita il campo e richiede l'aggiornamento.
    // Verrà riabilitato ad aggiornamento completato.
    this.loading = true;
    await this.$store.dispatch('updateConnectionFields', {
      id: this.connection?.id,
      fields: update,
      force: true, // Applica immediatamente l'aggiornamento
    });
    this.loading = false;
  }
}

